/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MarketingChannelOverviewCollectionData } from './MarketingChannelOverviewCollectionData';
import {
    MarketingChannelOverviewCollectionDataFromJSON,
    MarketingChannelOverviewCollectionDataFromJSONTyped,
    MarketingChannelOverviewCollectionDataToJSON,
    MarketingChannelOverviewCollectionDataToJSONTyped,
} from './MarketingChannelOverviewCollectionData';
import type { ShopPerformance } from './ShopPerformance';
import {
    ShopPerformanceFromJSON,
    ShopPerformanceFromJSONTyped,
    ShopPerformanceToJSON,
    ShopPerformanceToJSONTyped,
} from './ShopPerformance';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface OverviewCompositionData
 */
export interface OverviewCompositionData {
    /**
     * 
     * @type {ShopPerformance}
     * @memberof OverviewCompositionData
     */
    shopPerformance?: ShopPerformance;
    /**
     * 
     * @type {MarketingChannelOverviewCollectionData}
     * @memberof OverviewCompositionData
     */
    channels?: MarketingChannelOverviewCollectionData;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof OverviewCompositionData
     */
    snapshot?: PrecalculationSnapshotReadMetadata;
}

/**
 * Check if a given object implements the OverviewCompositionData interface.
 */
export function instanceOfOverviewCompositionData(value: object): value is OverviewCompositionData {
    return true;
}

export function OverviewCompositionDataFromJSON(json: any): OverviewCompositionData {
    return OverviewCompositionDataFromJSONTyped(json, false);
}

export function OverviewCompositionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverviewCompositionData {
    if (json == null) {
        return json;
    }
    return {
        
        'shopPerformance': json['shopPerformance'] == null ? undefined : ShopPerformanceFromJSON(json['shopPerformance']),
        'channels': json['channels'] == null ? undefined : MarketingChannelOverviewCollectionDataFromJSON(json['channels']),
        'snapshot': json['snapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
    };
}

export function OverviewCompositionDataToJSON(json: any): OverviewCompositionData {
    return OverviewCompositionDataToJSONTyped(json, false);
}

export function OverviewCompositionDataToJSONTyped(value?: OverviewCompositionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shopPerformance': ShopPerformanceToJSON(value['shopPerformance']),
        'channels': MarketingChannelOverviewCollectionDataToJSON(value['channels']),
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
    };
}

